export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      communityUuid: "community002",
      communityNumber: "1002",
      name: "アイラ地域サポート",
      note: "xxxxxx",
      status: 1,
      createdAt: 1594880785395,
      tenant: {
        tenantUuid: "tenant001",
        name: "xxxxxx",
        nameKana: "xxxxxx",
        status: 1
      },
      deviceTypes: [
        {
          deviceTypeUuid: "xxxxxx",
          modelNumber: "xxxxxx",
          modelName: "JS01H",
          manufacturerName: "xxxxxx",
          status: 1,
          createdAt:1594880785395
        },
        {
          deviceTypeUuid: "xxxxxx",
          modelNumber: "xxxxxx",
          modelName: "JH01K",
          manufacturerName: "xxxxxx",
          status: 1,
          createdAt:1594880785395
        }
      ],
      communityTantous: [
        {
          userUuId: "xxxxxx",
          name: "どい",
          status: 1
        }
      ]
    }
  }
}